import { createAction } from '@ngrx/store';
import { fareRulesFeatureKey } from './fare-rules.state';

export const initializeFareRulesState = createAction(`[${fareRulesFeatureKey}] Initialize FareRules state`);

export const setFareRulesState = createAction(
  `[${fareRulesFeatureKey}] Set FareRules state`,
  (fareBasisCodes: string[], classOfServiceOrBookingCodes: string[], operationalCarrierCodes: string[], endorsements: string[]) => ({
    fareBasisCodes,
    classOfServiceOrBookingCodes,
    operationalCarrierCodes,
    endorsements,
  })
);
